import React from "react";
import { useSarah } from "@unifize/sarah";

import { FailureText } from "./styles";

const Error = () => {
  const { colors } = useSarah();

  return (
    <div>
      <FailureText color={colors.text.negative}>Creation Failed!</FailureText>
      <span>
        Unifize AI is unable to generate suggestions at this time. Please try
        again later or contact support if the issue persists.
      </span>
    </div>
  );
};

export default Error;
